<template>
  <div id="app">
    <div class="herring-video-container">
      <video-bar></video-bar>
      <video id="video" class="video-js vjs-big-play-centered">
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a href="http://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
          </a>
        </p>
      </video>
      <div v-if="!showForm && !showConfirm && !!video" style="text-align:center;margin-top:32px">
        <button @click.prevent="showForm = true" class="herring-btn-lg">Enter Count</button>
      </div>
      <div v-if="showForm" style="margin-left:8px">
        <form @submit.prevent="submitCount" @submit="$v.$touch()">
          <div style="margin-top:32px">
            <label for="count" style="width:100%;display:block;font-size:1.3em;margin-top:16px;margin-bottom:12px">How many fish did you count?</label>
            <input
              class="field-element"
              type="text"
              name="count"
              v-model="form.count"
              style="display:block;width:100%">
            <div v-if="submitted && !$v.form.count.required" style="margin-top: 8px;color: red">
              Count is required and must be a number.
            </div>
            <div v-if="submitted && !$v.form.count.numeric" style="margin-top: 8px;color: red">
              Count must be a number (no commas, spaces, or periods!).
            </div>
          </div>
          <div style="margin-top:32px">
            <label for="comment" style="width:100%;display:block;font-size:1.3em;margin-top:16px;margin-bottom:4px">
              Any comments about the video? See anything interesting? <i>(optional)</i>
            </label>
            <input type="text" name="comment" v-model="form.comment" style="display:block;width:100%">
          </div>
          <div v-if="!submitting" style="margin-top:16px;text-align:center">
            <input
              type="submit"
              value="Submit"
              style="margin-right:12px;font-size:1.2em">
            <input
              type="submit"
              value="Cancel"
              @click.prevent="resetForm"
              style="margin-right:12px;font-size:1.2em">
          </div>
          <div v-if="submitting" style="margin-top:8px">
            <strong>Submitting count, please wait...</strong>
          </div>
        </form>
      </div>
      <div v-if="showConfirm" style="margin-left:8px;text-align:center;padding-top:16px">
        <h3 v-if="!flag">{{ confirmMessage }}</h3>
        <div v-else>
          <h3>Hmmm... </h3>
          <p><strong>{{ flag }}</strong></p>
        </div>
        <div style="margin-top:16px;text-align:center">
          <button @click.prevent="showNext" class="herring-btn-lg">Let's watch another!</button>
        </div>
      </div>
    </div>

    <hr style="margin-top:24px;margin-bottom:32px">

    <DataSummary></DataSummary>

    <hr>

    <p>
      To find out more about the NSRWA's work to monitor and restore river herring to our local rivers visit the following pages on our website:
    </p>
    <ul>
      <li>
        <a href="https://www.nsrwa.org/get-involved/citizen-science/river-herring-counts/" target="_blank">River Herring Counts</a>
      </li>
      <li>
        <a href="https://www.nsrwa.org/protect-our-waters/healthy-rivers/dam-removal" target="_blank">Dam Removals</a>
      </li>
      <li>
        <a href="https://www.nsrwa.org/protect-our-waters/healthy-rivers/dam-removals/third-herring-brook-restoration/" target="_blank">Third Herring Brook Restoration</a>
      </li>
      <li>
        <a href="https://www.nsrwa.org/protect-our-waters/healthy-rivers/dam-removals/south-river-restoration/" target="_blank">South River Restoration</a>
      </li>
      <li>
        <a href="https://www.nsrwa.org/protect-our-waters/healthy-rivers/streamflow-restoration/first-herring-brook-restoration/" target="_blank">First Herring Brook Streamflow Restoration</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import videojs from 'video.js'
import { required, numeric } from 'vuelidate/lib/validators'

import VideoBar from '@/components/VideoBar'
import DataSummary from '@/components/DataSummary'
import uuid from '@/lib/uuid'
import { number } from '@/filters'
import evt from '@/events'

const messages = [
  'Great job!',
  'Thank you!',
  'Nice work!',
  'Bravo!',
  'Well done!',
  'Excellent!',
  'Fantastic!',
  'Way to go!'
]

export default {
  name: 'App',
  components: {
    VideoBar,
    DataSummary
  },
  filters: {
    number
  },
  data () {
    return {
      showForm: false,
      showConfirm: false,
      loading: false,
      submitted: false,
      submitting: false,
      confirmMessage: null,
      form: {
        count: null,
        comment: null
      },
      flag: null,
      player: null
    }
  },
  computed: {
    ...mapGetters(['video', 'session', 'run']),
    title () {
      return `I just counted ${this.session.total} river herring migrating up Town Brook!`
    }
  },
  watch: {
    video (video) {
      console.log('videoPlayer:watch(video)', video)
      if (video) {
        this.loadVideo(video)
      } else {
        console.log('video:loadVideo no video')
      }
    }
  },
  validations: {
    form: {
      count: {
        required,
        numeric
      }
    }
  },
  created () {
    this.$store.dispatch('setSessionId', uuid())
  },
  mounted () {
    this.$store.dispatch('fetchVideo')
      .catch(err => console.log(err))
    this.$store.dispatch('fetchRun')
      .catch(err => console.log(err))

    this.player = videojs('video', {
      controls: true,
      autoplay: false,
      width: 700,
      height: 500,
      playbackRates: [0.1, 0.25, 0.5, 1],
      inactivityTimeout: 0
    })

    this.player.ready(() => {
      this.player.on('loadstart', () => {
        console.log('video:loadstart')
      })
      this.player.on('loadeddata', () => {
        console.log('video:loadeddata', this.player.currentSource())
        // this.loading = false;
      })
      this.player.on('error', () => {
        console.log('video:error')
        // this.error = true;
      })
      this.player.on('abort', () => {
        console.log('video:abort')
        // this.error = true;
      })
      this.player.on('ended', () => {
        console.log('video:ended')
      })
    })

    if (this.video) {
      this.loadVideo(this.video)
    }
  },
  beforeDestroy () {
    console.log('video:beforeDestroy')
    this.player.dispose()
  },
  methods: {
    loadVideo (video) {
      console.log('video:loadVideo loaded id=', video.id)

      const src = []
      src.push({ type: 'video/mp4', src: video.url })

      if (video.url_webm) {
        src.push({ type: 'video/webm', src: video.url_webm })
      }

      this.player.src(src)
      this.player.load()
    },
    submitCount () {
      if (this.loading || !this.player) return

      this.submitted = true
      this.flag = null

      const duration = this.player.duration()
      const timeRanges = this.player.played()

      let totalTimeWatched = 0
      for (let i = 0; i < timeRanges.length; i++) {
        const start = timeRanges.start(i)
        const end = timeRanges.end(i)
        totalTimeWatched += (end - start)
      }
      const percentWatched = totalTimeWatched / duration

      console.log(percentWatched, totalTimeWatched, duration)

      if (percentWatched < 0.01) {
        this.flag = 'It doesn\'t look like you watched any of the video. This count has been flagged for review.'
      } else if (percentWatched < 0.9) {
        this.flag = 'It doesn\'t look like you watched the entire video. This count has been flagged for review.'
      }

      if (!this.$v.$invalid) {
        this.submitting = true

        const payload = {
          video_id: this.video.id,
          count: +this.form.count,
          comment: this.form.comment,
          session: this.session.id,
          flagged: !!this.flag
        }

        this.$http.post('/count/', payload)
          .then((response) => {
            if (!this.flag && response.data.data[0].flagged) {
              this.flag = 'That count seems a little questionable. It has been flagged for our review.'
            }
            this.$store.dispatch('updateSession', payload.count)
            evt.$emit('refresh')
          })
          .then(() => this.$store.dispatch('fetchRun'))
          .then(() => {
            this.resetForm()
            this.updateConfirmMessage()
            this.showConfirm = true
            this.submitting = false
          })
          .catch((response) => {
            alert('Error occurred saving count to the server, try submitting again.\n\nIf the problem continues, please let us know.')
            console.log(response)
            this.loading = false
            this.submitting = false
          })
      }
    },
    updateConfirmMessage () {
      if (this.session.lastCount === 0) {
        this.confirmMessage = 'No fish in that one? Thanks for letting us know!'
      } else {
        this.confirmMessage = messages[Math.floor(Math.random() * messages.length)]
      }
    },
    resetForm () {
      this.form.count = null
      this.form.comment = null
      this.submitted = false
      this.showForm = false
    },
    showNext () {
      this.showForm = false
      this.showConfirm = false
      this.$store.dispatch('fetchVideo')
    }
  }
}
</script>

<style>
.herring-video-container {
  max-width: 700px;
  margin: 0 auto;
}
.herring-btn-lg {
  font-size: 1.5em;
  font-weight: 800;
  padding: .5rem 1rem;
}
.video-js {
  border-radius: 0px 0px 8px 8px;
}
</style>
